import type { Dtos } from "@inrev/common";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { type PelPmlCalculationInput, pelPmlCalculationQueryKey } from "../pel-pml.keys";

export const useCalculatePelPml = (input: PelPmlCalculationInput | null) => {
	const { post } = useRequest();

	return useQuery({
		queryKey: pelPmlCalculationQueryKey(input),
		enabled: input !== null,
		placeholderData: keepPreviousData,
		queryFn: async () =>
			await post<Dtos.Admin.PelPml.Calculate.Response>(
				"/v2/admin/surety/pel-pml/calculate",
				input ?? undefined,
			),
	});
};
